import React from 'react';
import { AccordionHeaderProps, AccordionHeader as BSAccordionHeader } from 'react-bootstrap';

import ButtonText from 'components/Typography/ButtonText';

import './index.scss';

export const ACCORDION_VARIANTS = ['primary', 'secondary', 'nested'] as const;

type AccordionProps = AccordionHeaderProps & { variant?: typeof ACCORDION_VARIANTS[number] };

export default function AccordionHeader({
  children,
  className = '',
  variant = 'primary',
  ...otherProps
}: AccordionProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BSAccordionHeader className={`ds-accordion-header-${variant} ${className}`} {...otherProps}>
      {variant === 'primary' && <ButtonText>{children}</ButtonText>}
      {variant !== 'primary' && children}
    </BSAccordionHeader>
  );
}
